import { LoginPopInfo } from '@/api/apiRsp/IFActivityList';
import ButtonUI from '@/componentsUI/Button';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import PopupMask from '@/componentsUI/PopupMask';
import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import React from 'react';

const LoginPopup = NiceModal.create((props: any) => {
  const { visible, remove, resolve } = useModal();
  const { t } = useTranslationPlus('UserInput');
  const prefixCls = 'login-popup';

  const { title, content } = props;

  const onClickOk = () => {
    resolve(true);
    remove();
  };

  return (
    <PopupMask visible={visible}>
      <div className={`${prefixCls}-body`}>
        <div className="title">
          <p>{title}</p>
        </div>
        <div className="message">
          <div
            dangerouslySetInnerHTML={{
              __html: content ? content : '',
            }}
          ></div>
        </div>
        <div className="btns">
          <ButtonUI type={'primary'} className="btn" onClick={onClickOk}>
            {t('OK')}
          </ButtonUI>
        </div>
      </div>
    </PopupMask>
  );
});

export default LoginPopup;
